import {MdbsCore} from "@/api/tsclient";
import QueryTypeDefinitionDto = MdbsCore.QueryTypeDefinitionDto;
import {currentUserModule} from "@/store";
import Rights = MdbsCore.Rights;
import IQueryTypeDefinitionDto = MdbsCore.IQueryTypeDefinitionDto;


export const canSeeQueryDefinition = function(queryDefinition: QueryTypeDefinitionDto) : boolean{
    if (!queryDefinition)
        return false;

    const canView = queryDefinition.definition.canView as Array<string>;
    if (!canView) return false;
    return canView.includes(currentUserModule.roleIdentifier);
}

export const canCreateQuery = function(definition: QueryTypeDefinitionDto): boolean {
    const canCreate = definition.definition.canCreate as Array<string>;
    if (!canCreate) return false;

    return currentUserModule.hasRight(Rights.QueryCreateCmd) && canCreate.includes(currentUserModule.roleIdentifier);
}

export const canSeeQueries = function(referenceType: string | undefined): boolean {
    if (!referenceType)
        return false;

    if (referenceType == "PatientDefinition")
        return currentUserModule.hasRight(Rights.QueryGetAllForPatientCmd);
    if (referenceType == "VisitDefinition")
        return currentUserModule.hasRight(Rights.QueryGetAllForVisitCmd);
    if (referenceType == "InstrumentDefinition")
        return currentUserModule.hasRight(Rights.QueryGetAllForInstrumentCmd);

    return false;
}

export const canSeeInstrumentQueries = function(): boolean {
    return currentUserModule.hasRight(Rights.QueryGetForInstrumentCmd);
}

export const canSeeVisitQueries = function(): boolean {
    return currentUserModule.hasRight(Rights.QueryGetForVisitCmd);
}

export const canSeePatientQueries = function(): boolean {
    return currentUserModule.hasRight(Rights.QueryGetForPatientCmd);
}

export const canSeeInstituteQueries = function(): boolean {
    return currentUserModule.hasRight(Rights.QueryGetForInstituteCmd);
}

export const  canEditQuery = function(queryTypeDefinition: IQueryTypeDefinitionDto) {
    const canEdit = queryTypeDefinition.definition.canEdit as Array<string>;
    if (!canEdit) return false;

    return canEdit.includes(currentUserModule.roleIdentifier) &&
        currentUserModule.hasRight(Rights.QueryEditCmd);
}

export const  canAcceptQuery = function(queryTypeDefinition: IQueryTypeDefinitionDto) {
    const canAccept = queryTypeDefinition.definition.canAccept as Array<string>;
    if (!canAccept) return false;

    return canAccept.includes(currentUserModule.roleIdentifier) &&
        currentUserModule.hasRight(Rights.QueryAcceptCmd);
}

export const  canAnswerQuery = function(queryTypeDefinition: IQueryTypeDefinitionDto) {
    const canAnswer = queryTypeDefinition.definition.canAnswer as Array<string>;

    if (!canAnswer) return false;

    return canAnswer.includes(currentUserModule.roleIdentifier) &&
        currentUserModule.hasRight(Rights.QueryAnswerCmd);
}

export const  canRevokeQuery = function(queryTypeDefinition: IQueryTypeDefinitionDto) {
    const canRevoke = queryTypeDefinition.definition.canRevoke as Array<string>;

    if (!canRevoke) return false;
    return canRevoke.includes(currentUserModule.roleIdentifier) &&
        currentUserModule.hasRight(Rights.QueryRevokeCmd);
}

export const  canSolveQuery = function(queryTypeDefinition: IQueryTypeDefinitionDto) {
    const canSolve = queryTypeDefinition.definition.canSolve as Array<string>;
    if (!canSolve) return false;

    return canSolve.includes(currentUserModule.roleIdentifier) &&
        currentUserModule.hasRight(Rights.QuerySolveCmd);
}

export const  canDeferQuery = function(queryTypeDefinition: IQueryTypeDefinitionDto) {
    const canDefer = queryTypeDefinition.definition.canDefer as Array<string>;
    if (!canDefer) return false;

    return canDefer.includes(currentUserModule.roleIdentifier) &&
        currentUserModule.hasRight(Rights.QueryDeferCmd);
}
